import {
  isMapboxURL,
  transformMapboxUrl,
} from 'maplibregl-mapbox-request-transformer';

function isMapboxHost(url) {
  return url.includes('.mapbox.com');
}

function transformMapboxProtocol(url, resourceType, accessToken) {
  const tileSource =
    process.env.REACT_APP_C3D_TILE_SOURCE || process.env.REACT_APP_TILE_SOURCE;

  if (resourceType === 'Glyphs' && tileSource && !url.includes('/concept3d/')) {
    const fontSource = tileSource.replace('/maps/', '/fonts/');
    const fontPath =
      url.match(/^mapbox:\/\/fonts\/[^/]+\/(.+)$/)?.[1] ?? '';
    return {
      url: `${fontSource}${decodeURIComponent(fontPath)}`,
      headers: {},
    };
  }

  if (resourceType === 'Source' && url.includes('?style=')) {
    const [base, query = ''] = url.split('?');
    const transformed = transformMapboxUrl(base, 'Source', accessToken);
    if (!transformed?.url) {
      return transformed;
    }
    const separator = transformed.url.includes('?') ? '&' : '?';
    return {
      ...transformed,
      url: `${transformed.url}${separator}${query}`,
    };
  }

  return transformMapboxUrl(url, resourceType, accessToken);
}

export function handleMapboxTransformRequest(
  url = '',
  resourceType = '',
  token
) {
  const accessToken = token || process.env.REACT_APP_MAPBOX_KEY;

  if (isMapboxURL(url)) {
    return transformMapboxProtocol(url, resourceType, accessToken);
  }
  if (isMapboxHost(url)) {
    return undefined;
  }
  return { url, headers: {} };
}
